import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_a9b3b023: FaireBrandEntity = {
  token: "b_a9b3b023",
  type: "brand",
  name: "P.F. Candle Co.",
  avatarUrl:
    "https://cdn.faire.com/fastly/d90320ac767e6018793a450e94b4c8ad4ec7964218ad8f091221709bc1f92fe1.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/2d1e888c1c8e79c04d3b97e4c08146966ae729cfcd4364022d7e561a42bdcd99.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/d90320ac767e6018793a450e94b4c8ad4ec7964218ad8f091221709bc1f92fe1.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/2d1e888c1c8e79c04d3b97e4c08146966ae729cfcd4364022d7e561a42bdcd99.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 250,
  rating: 4.9,
  reviewCount: 603,
  isInsider: true,
  description:
    "Hi, we're P.F. Candle Co. — an independently owned & operated home fragrance company based in sunny Los Angeles. As we grow, so does our commitment to sustainability, high-quality products, and to our crew who makes it all happen. We believe that fragrance is an extension of home design, and create products with accessible price points in mind. Our entire collection of 100% soy wax candles, room sprays, reed diffusers, incense, and air fresheners are vegan, cruelty-free, and phthalate-free — always. We are a proud Climate Neutral Certified company!",
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:06:22.535Z",
    importedBy: "entity-db-cli",
  },
};
